import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'name': 'String',
	'email': 'String!',
};

export default gql(`
	mutation employee_external( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_external( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        name
	    }
	}
`);

